import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectApi(data) {
  return request({
    url: `/admin/informationList/select`,
    method: "POST",
    data,
    // isEncrypt:false,
    // isDecrypt:false
  });
}

/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addApi(data) {
  return request({
    url: `/admin/informationList/add`,
    method: "POST",
    data,
  });
}

/**
 * 更改
 * @param {*} data
 * @returns
 */
export function updateApi(data) {
  return request({
    url: `/admin/informationList/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteApi(data) {
  return request({
    url: `/admin/informationList/delete`,
    method: "POST",
    data
  });
}
